
import { windowWidth } from "./utils";
import { Popup } from "./popup";

const mobMenu = {

  menus: document.querySelectorAll('.jsMenuWrap') as NodeListOf<HTMLElement>,  

  init() {
    this.setPopups()
    this.mobileMenuFn();    

  },
  setPopups(){
    if(windowWidth < 1200){
      const filter = new Popup("#filterMenu", "#prodFilter", ".jsClose");
      filter.init();
    
    }
    const menu = new Popup("#mobMenu", "#openMenu", ".jsClose");
    menu.init();  

    const finder = new Popup("#partsFinder", ".jsOpenPartsFinder", ".jsClose");
    finder.init(); 

    const search = new Popup("#searchPopup", "#openSearch", ".jsClose");
    search.init(); 
  },
  createEvent(item: Element, menu: HTMLElement) {
      const el = item.querySelector(".jsBack");
      el?.addEventListener('click', (e) => {
          e.preventDefault();
        item.classList.remove('activeClass');
        menu.classList.remove('activeClass');
      });
  },
  mobileMenuFn() {
    this.menus.forEach(el=>{
     const dropdowns = el.querySelectorAll('.jsNextLvl') as NodeListOf<HTMLElement>    
     dropdowns.forEach((item) => {       
          const subMenu = item.nextElementSibling;
          item.addEventListener('click', (e) => {            
              e.preventDefault();               
              if(subMenu){
                subMenu.classList.add('activeClass');                
                el.scrollTop = 0
                el.classList.add('activeClass');
                this.createEvent(subMenu, el);
              }
          
          
          });
      });
    })
  }
 

}

export default mobMenu;

